import { Button, Col, Form, List, notification, Row, Spin, Tabs } from 'antd';
import axios from 'axios';
import { getFileName, getLangValueParams, getValueFromLanguageSet, localize } from 'mixins/helpers';
import React, { useEffect, useState } from 'react';
import 'react4xp/parts/service-unreliable-taxpayers/service-unreliable-taxpayers.scss';
import { IDGDitem } from './interfaces/IDGDitem';
import { ICategory } from '/react4xp/parts/manage-reestr-list/manage-reestr-list.type';
import {
    documentHistoryCategories,
    getTaxOrg,
} from '/react4xp/parts/service-unreliable-taxpayers/actions';

const DOC_CATS_URL = `/services/isnaportal/open-api/admin/document-history/categories`;
const DOWNLOAD_URL = `/services/isnaportal/open-api/taxpayer-data/export`;
const TAX_ORG_SEARCH = `/services/isnaportal/open-api/tax-org/search`;
const DOWNLOAD_URL_EXCEL = `/services/isnaportal/open-api/taxpayer-data/export/excel`;

const DOCUMENT_CATEGORIES_WITH_EXCEL = [
    'REREGISTRATION_INVALID',
    'REGISTRATION_INVALID',
    'INACTIVE',
    'BANKRUPT',
];

const documentCategorySortOrder = {
    BANKRUPT: 1,
    INACTIVE: 3,
    REGISTRATION_INVALID: 4,
    REREGISTRATION_INVALID: 5,
    ABSENT_ADDRESS: 6,
};

const dgdSortOrder = {
    '6201': 19,
    '6001': 20,
    '5901': 21,
};

const NOT_RELATED_DOCUMENT_CATEGORIES = [
    'REGISTER',
    'ADMITTED_FOR_EXAM',
    'LIST_OF_ADMITTED_EXAM_QUESTIONS',
    'PSEUDO_ENTERPRISE',
];

type TabPosition = 'left' | 'right' | 'top' | 'bottom';

const ListForm = (props: any) => {
    const [form] = Form.useForm();
    const [tabPosition, setTabPosition] = useState<TabPosition>('left');
    const [dgdData, setDgdData] = useState<IDGDitem[]>();
    const [categoryData, setCategoryData] = useState<ICategory[]>([]);
    const [isDownloading, setIsDownloading] = useState<string>();
    const [isLoading, setIsLoading] = useState(false);

    const loadData = () => {
        setIsLoading(true);

        getTaxOrg()
            .then((results) => {
                const dgd_items = results.data.sort((a: IDGDitem, b: IDGDitem) => {
                    const orderA = dgdSortOrder[a.code] || Number.MAX_SAFE_INTEGER;
                    const orderB = dgdSortOrder[b.code] || Number.MAX_SAFE_INTEGER;
                    return orderB - orderA;
                });

                setDgdData(dgd_items);
            })
            .finally(() => setIsLoading(false));

        documentHistoryCategories().then((result) => {
            const tab_items = result.data;

            const filtered_tab_items = tab_items
                .filter((item) => !NOT_RELATED_DOCUMENT_CATEGORIES.includes(item.documentCategory))
                .sort((a: any, b: any) => {
                    const orderA =
                        documentCategorySortOrder[a.documentCategory] || Number.MAX_SAFE_INTEGER;
                    const orderB =
                        documentCategorySortOrder[b.documentCategory] || Number.MAX_SAFE_INTEGER;

                    return orderA - orderB;
                });

            setCategoryData(filtered_tab_items);
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    const downloadXlsFile = (type: string, dgdCode: string) => {
        setIsDownloading(dgdCode);
        axios({
            url:
                DOCUMENT_CATEGORIES_WITH_EXCEL.indexOf(type) !== -1
                    ? DOWNLOAD_URL_EXCEL
                    : DOWNLOAD_URL,
            method: 'GET',
            responseType: 'blob',
            params: {
                language: props.language === 'en_US' ? 'eng' : getLangValueParams(props.language),
                type: type,
                taxOrgCode: dgdCode,
            },
        })
            .then((response) => {
                const filename =
                    getFileName(response.headers['content-disposition']) ||
                    `export_${type}_${dgdCode}`;
                const url = URL.createObjectURL(response.data);

                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                link.click();
            })
            .catch((error) => {
                notification['warning']({
                    message: 'По выбранному региону данные отсутствуют',
                });
            })
            .finally(() => setIsDownloading(null));
    };

    const getListItemFromType = (item: ICategory) => {
        return (
            <List
                size="large"
                dataSource={dgdData}
                renderItem={(dgd) => (
                    <List.Item
                        actions={[
                            <Button
                                size="large"
                                loading={isDownloading === dgd.code}
                                onClick={() => {
                                    downloadXlsFile(item.documentCategory, dgd.code);
                                }}
                            >
                                {localize('button.download', props?.translations)}
                            </Button>,
                        ]}
                    >
                        <span className="dgd-name">
                            {getValueFromLanguageSet(
                                dgd,
                                props.language === 'en_US'
                                    ? 'eng'
                                    : getLangValueParams(props.language)
                            )}
                        </span>
                    </List.Item>
                )}
            />
        );
    };

    return (
        <div className="list-form">
            <Spin spinning={isLoading}>
                <Form
                    name="ListUnreliableTaxpayers"
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={{ xs: 8, md: 20 }}>
                        <Col
                            xs={24}
                            md={24}
                        >
                            <Tabs
                                type="card"
                                tabPosition={tabPosition}
                                size="large"
                                items={categoryData.map((item, i) => {
                                    const id = String(i + 1);
                                    return {
                                        label: getValueFromLanguageSet(
                                            item.name,
                                            props.language === 'en_US'
                                                ? 'eng'
                                                : getLangValueParams(props.language)
                                        ),
                                        key: id,
                                        children: getListItemFromType(item),
                                    };
                                })}
                            />
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div>
    );
};

export default ListForm;
